import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { LogOut } from 'lucide-react';
import './App.css';
import Login from './components/Login';
import ClientePanel from './components/ClientePanel';
import StaffPanel from './components/StaffPanel';
import ErrorBoundary from './components/ErrorBoundary';
import { getToken, getUsuario, getRol, cerrarSesion } from './api';
import ecuaflyNavbarLogo from './assets/ecuafly-navbar.png';

const TOASTER_OPTIONS = {
  style: {
    fontSize: '13px',
    fontFamily: 'var(--font-sans)',
    borderRadius: 'var(--radius-md)',
    color: 'var(--color-text-primary)',
  },
  success: { iconTheme: { primary: 'var(--color-success)', secondary: '#fff' } },
  error: { iconTheme: { primary: 'var(--color-error)', secondary: '#fff' } },
};

function App() {
  const [autenticado, setAutenticado] = useState(!!getToken());
  const [rol, setRol] = useState(getRol());

  const handleLogin = (userRol) => {
    setAutenticado(true);
    setRol(userRol);
  };

  const handleLogout = () => {
    cerrarSesion();
    setAutenticado(false);
    setRol(null);
  };

  if (!autenticado) {
    const params = new URLSearchParams(window.location.search);
    return (
      <div className="App">
        <Toaster position="bottom-right" toastOptions={TOASTER_OPTIONS} />
        <Login
          onLogin={handleLogin}
          resetToken={params.get('reset_token')}
          activarToken={params.get('activar_token')}
          uid={params.get('uid')}
        />
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="bottom-right" toastOptions={TOASTER_OPTIONS} />

      <header className="App-header">
        <h1>
          <img src={ecuaflyNavbarLogo} alt="Ecuafly" style={{ height: '28px', width: '28px', borderRadius: '8px', verticalAlign: 'middle', objectFit: 'cover' }} />
          <span className="App-header__title-text">Ecuafly · Panel de paquetes</span>
        </h1>
        <div className="App-header__user">
          <span className="App-header__rol">{rol}</span>
          <span className="App-header__username">{getUsuario()}</span>
          <button onClick={handleLogout} className="btn-header">
            <LogOut size={14} /> Cerrar sesión
          </button>
        </div>
      </header>

      <main className={rol === 'admin' ? 'main--con-sidebar' : undefined}>
        <ErrorBoundary>
          {rol === 'cliente' ? <ClientePanel /> : <StaffPanel rol={rol} />}
        </ErrorBoundary>
      </main>
    </div>
  );
}

export default App;
